/* AlmaBeauty custom motion layer.
   Progressive enhancement only: content is never hidden by a static CSS
   rule. Shopify's theme editor / preview can re-render section markup after
   first paint, which previously raced against a CSS-driven "starts hidden"
   rule and left content invisible. Instead, GSAP's own `fromTo` sets the
   "from" state as an inline style at the exact moment each animation is
   created (synchronous JS, not a persistent CSS rule), then tweens to
   visible. If GSAP/ScrollTrigger fail to load, this script just returns
   early and every element stays at its natural, fully visible state. */

(function () {
  /* Wishlist heart toggle — localStorage only, no GSAP dependency. */
  var WISHLIST_KEY = 'almabeauty_wishlist';
  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function writeWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {
      /* ignore quota/private-mode errors */
    }
  }
  function updateWishlistBubble() {
    var list = readWishlist();
    document.querySelectorAll('[data-alma-wishlist-count]').forEach(function (bubble) {
      var span = bubble.querySelector('span[aria-hidden="true"]');
      if (span) span.textContent = list.length;
      bubble.hidden = list.length === 0;
    });
  }

  var wishlist = readWishlist();
  document.querySelectorAll('[data-alma-wishlist]').forEach(function (btn) {
    var id = btn.dataset.productId;
    if (wishlist.indexOf(id) !== -1) btn.classList.add('is-active');
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var index = wishlist.indexOf(id);
      if (index === -1) {
        wishlist.push(id);
        btn.classList.add('is-active');
      } else {
        wishlist.splice(index, 1);
        btn.classList.remove('is-active');
      }
      writeWishlist(wishlist);
      updateWishlistBubble();
      if (window.gsap) {
        window.gsap.fromTo(btn, { scale: 1.35 }, { scale: 1, duration: 0.3, ease: 'back.out(3)' });
      }
    });
  });
  updateWishlistBubble();

  /* Wishlist page — show only the products saved in localStorage among the
     full (hidden-by-default) set of cards rendered by the section. */
  var wishlistGrid = document.querySelector('[data-alma-wishlist-grid]');
  if (wishlistGrid) {
    var savedIds = readWishlist();
    var emptyState = document.querySelector('[data-alma-wishlist-empty]');
    var loadingState = document.querySelector('[data-alma-wishlist-loading]');
    var visibleCount = 0;
    wishlistGrid.querySelectorAll('[data-alma-wishlist-product]').forEach(function (item) {
      if (savedIds.indexOf(item.dataset.almaWishlistProduct) !== -1) {
        item.hidden = false;
        visibleCount += 1;
      }
    });
    if (loadingState) loadingState.hidden = true;
    if (visibleCount > 0) {
      wishlistGrid.hidden = false;
    } else if (emptyState) {
      emptyState.hidden = false;
    }
  }

  /* Carousel prev/next — plain scroll behavior, doesn't depend on GSAP. */
  document.querySelectorAll('[data-alma-carousel-prev], [data-alma-carousel-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = btn.closest('.alma-carousel-collections, .alma-lines');
      var track = wrapper && (wrapper.querySelector('[data-alma-carousel-track]') || wrapper.querySelector('.alma-lines__track'));
      if (!track) return;
      var amount = Math.min(track.clientWidth * 0.8, 600);
      var dir = btn.hasAttribute('data-alma-carousel-prev') ? -1 : 1;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    });
  });

  /* Announcement bar — rotate one message at a time on desktop, every 3s,
     with manual prev/next arrows that reset the auto-advance timer.
     Mobile keeps its own infinite scrolling ticker (pure CSS), untouched. */
  var almaAnnounceSlide = document.querySelector('[data-alma-announce-slide]');
  if (almaAnnounceSlide && window.matchMedia('(min-width: 750px)').matches) {
    var almaAnnounceMessages = almaAnnounceSlide.querySelectorAll(
      '.alma-announce__messages:not(.alma-announce__messages--duplicate) > .alma-announce__message'
    );
    if (almaAnnounceMessages.length > 1) {
      var almaAnnounceIndex = 0;
      var almaAnnounceTimer;
      almaAnnounceMessages[0].classList.add('is-active');

      function almaAnnounceGoTo(nextIndex) {
        almaAnnounceMessages[almaAnnounceIndex].classList.remove('is-active');
        almaAnnounceIndex = (nextIndex + almaAnnounceMessages.length) % almaAnnounceMessages.length;
        almaAnnounceMessages[almaAnnounceIndex].classList.add('is-active');
      }

      function almaAnnounceStartTimer() {
        window.clearInterval(almaAnnounceTimer);
        almaAnnounceTimer = window.setInterval(function () {
          almaAnnounceGoTo(almaAnnounceIndex + 1);
        }, 3000);
      }

      document.querySelectorAll('[data-alma-announce-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          almaAnnounceGoTo(almaAnnounceIndex - 1);
          almaAnnounceStartTimer();
        });
      });
      document.querySelectorAll('[data-alma-announce-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          almaAnnounceGoTo(almaAnnounceIndex + 1);
          almaAnnounceStartTimer();
        });
      });

      almaAnnounceStartTimer();
    }
  }

  /* Mobile nav drawer. */
  var almaDrawer = document.querySelector('[data-alma-drawer]');
  if (almaDrawer) {
    var drawerOpeners = document.querySelectorAll('[data-alma-drawer-open]');
    var drawerClosers = almaDrawer.querySelectorAll('[data-alma-drawer-close]');

    function openAlmaDrawer() {
      almaDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      drawerOpeners.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
    }
    function closeAlmaDrawer() {
      almaDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
      drawerOpeners.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    drawerOpeners.forEach(function (btn) {
      btn.addEventListener('click', openAlmaDrawer);
    });
    drawerClosers.forEach(function (el) {
      el.addEventListener('click', closeAlmaDrawer);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAlmaDrawer();
    });
  }

  /* Header categories mega-menu — open the whole panel on hover (desktop), keep native click-to-toggle for touch/keyboard. */
  document.querySelectorAll('.alma-header__nav-item--categories').forEach(function (item) {
    var details = item.querySelector('details');
    if (!details) return;
    var closeTimer;
    item.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      details.open = true;
    });
    item.addEventListener('mouseleave', function () {
      closeTimer = window.setTimeout(function () {
        details.open = false;
      }, 150);
    });
  });

  /* Header categories mega-menu — hover/click a sidebar tab to switch panel. */
  document.querySelectorAll('[data-alma-categories-menu]').forEach(function (menu) {
    var tabs = menu.querySelectorAll('[data-alma-category-tab]');
    var panels = menu.querySelectorAll('[data-alma-category-panel]');
    function activate(handle) {
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-alma-category-tab') === handle);
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-alma-category-panel') === handle);
      });
    }
    tabs.forEach(function (tab) {
      var handle = tab.getAttribute('data-alma-category-tab');
      tab.addEventListener('mouseenter', function () {
        activate(handle);
      });
      tab.addEventListener('click', function (event) {
        // Tabs that link to a collection navigate; the rest only switch panel.
        if (!tab.getAttribute('href')) event.preventDefault();
        activate(handle);
      });
      tab.addEventListener('focus', function () {
        activate(handle);
      });
    });
  });

  var hasGSAP = typeof window.gsap !== 'undefined';
  var hasScrollTrigger = typeof window.ScrollTrigger !== 'undefined';

  if (!hasGSAP || !hasScrollTrigger) {
    // Either library failed to load: content stays visible (default state),
    // we just skip the reveal animations entirely.
    return;
  }

  var gsap = window.gsap;
  gsap.registerPlugin(window.ScrollTrigger);

  /* ---------- Generic scroll reveal ---------- */
  document.querySelectorAll('[data-alma-reveal]').forEach(function (el) {
    var staggerTargets = el.querySelectorAll('[data-alma-stagger] > *');
    var targets = staggerTargets.length ? staggerTargets : el;

    gsap.fromTo(
      targets,
      { opacity: 0, y: 28 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power3.out',
        stagger: staggerTargets.length ? 0.08 : 0,
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true,
        },
      }
    );
  });

  /* ---------- Stock bar fill ---------- */
  document.querySelectorAll('.alma-stock-bar__fill').forEach(function (el) {
    var pct = el.closest('.alma-stock-bar').dataset.percent || 0;
    gsap.fromTo(
      el,
      { width: '0%' },
      {
        width: pct + '%',
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 90%', once: true },
      }
    );
  });

  /* ---------- Review rating bars ---------- */
  document.querySelectorAll('.alma-reviews__bar-fill').forEach(function (el) {
    var pct = el.dataset.pct || 0;
    gsap.fromTo(
      el,
      { width: '0%' },
      {
        width: pct + '%',
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 95%', once: true },
      }
    );
  });

  /* ---------- FAQ accordion smooth height ---------- */
  document.querySelectorAll('.alma-faq__item').forEach(function (details) {
    var content = details.querySelector('p');
    var summary = details.querySelector('summary');
    if (!content || !summary) return;

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = details.hasAttribute('open');

      if (isOpen) {
        gsap.to(content, {
          height: 0,
          opacity: 0,
          marginTop: 0,
          duration: 0.25,
          ease: 'power2.in',
          onComplete: function () {
            details.removeAttribute('open');
          },
        });
      } else {
        details.setAttribute('open', '');
        var target = content.scrollHeight;
        gsap.fromTo(
          content,
          { height: 0, opacity: 0, marginTop: 0 },
          { height: target, opacity: 1, marginTop: '1.2rem', duration: 0.35, ease: 'power2.out', onComplete: function () {
            content.style.height = 'auto';
          } }
        );
      }
    });
  });

  /* ---------- Countdown timer custom element ---------- */
  if (!customElements.get('alma-countdown')) {
    customElements.define(
      'alma-countdown',
      class extends HTMLElement {
        connectedCallback() {
          var duration = parseInt(this.dataset.durationSeconds, 10) || 0;
          this.target = Date.now() + duration * 1000;
          this.clockEl = this.querySelector('.alma-countdown__clock');
          this.tick();
          this.timer = setInterval(this.tick.bind(this), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        tick() {
          var remaining = Math.max(0, this.target - Date.now());
          var h = Math.floor(remaining / 3600000);
          var m = Math.floor((remaining % 3600000) / 60000);
          var s = Math.floor((remaining % 60000) / 1000);
          var pad = function (n) {
            return n.toString().padStart(2, '0');
          };
          if (this.clockEl) {
            this.clockEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
          }
          if (remaining <= 0) clearInterval(this.timer);
        }
      }
    );
  }

  /* ---------- Hero entrance + floating badges ---------- */
  var hero = document.querySelector('[data-alma-hero]');
  if (hero) {
    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    tl.fromTo(hero.querySelectorAll('[data-hero-eyebrow]'), { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.6 })
      .fromTo(hero.querySelectorAll('[data-hero-title]'), { opacity: 0, y: 28 }, { opacity: 1, y: 0, duration: 0.8 }, '-=0.35')
      .fromTo(hero.querySelectorAll('[data-hero-copy]'), { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.6 }, '-=0.4')
      .fromTo(hero.querySelectorAll('[data-hero-cta]'), { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.6 }, '-=0.4')
      .fromTo(hero.querySelectorAll('[data-hero-image]'), { opacity: 0, scale: 1.06 }, { opacity: 1, scale: 1, duration: 1.1 }, '-=0.9')
      .fromTo(hero.querySelectorAll('[data-hero-badge]'), { opacity: 0, scale: 0.6 }, { opacity: 1, scale: 1, duration: 0.5, stagger: 0.15 }, '-=0.5');

    gsap.to(hero.querySelectorAll('[data-hero-badge]'), {
      y: -10,
      duration: 2.4,
      ease: 'sine.inOut',
      yoyo: true,
      repeat: -1,
      stagger: { each: 0.3, from: 'random' },
    });
  }

  /* ---------- Product gallery thumbnail crossfade ---------- */
  document.querySelectorAll('[data-alma-crossfade-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = document.querySelector(btn.dataset.almaCrossfadeTrigger);
      if (!wrapper) return;
      gsap.fromTo(wrapper, { opacity: 0.3 }, { opacity: 1, duration: 0.3 });
    });
  });
})();
